<template>
    <div class="collapsible" id="manip-fluide" :class="stateClass">

        <!-- HEADER cliquable -->
        <div id="head-manip-fluide" @click="$emit('openCollapsible', 'manip-fluide')"
        class="w-full flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer transition select-none mb-5" :class="stateClass === 'open' ? 'bg-gray-700' : 'bg-gray-200'">
            <span class="uppercase font-semibold tracking-wide " :class="stateClass === 'open' ? 'text-white' : 'text-gray-700'">
                MANIPULATION DE FLUIDE FRIGORIGÈNE
            </span>
            <!-- Flèche dans un rond -->
            <div
                class="w-8 h-8 rounded-full flex items-center justify-center bg-white shadow text-secondary transition">
                <i class="inline-block h-6 w-6 mask mask-arrow-right bg-secondary transition-transform duration-300"
                    :class="stateClass === 'open' ? 'rotate-90' : 'rotate-0'"></i>
            </div>

        </div>

        <!-- CONTENU : visible seulement si "open" -->
        <div class="collapsible-body manip wrap" v-show="stateClass === 'open'">

            <div class="op-bouteille">
                <ul class="op-fiche bg-gray-100 rounded-xl p-2 space-y-3 mb-3" v-if="ops.length > 0">
                    <operation-component v-for="op in ops" :key="op.id" :operation="op"
                        @opDeleted="deleteOp"></operation-component>
                </ul>

                <a href="javascript: void 0" class="btn-secondary add-manip mb-5" id="op-fiche"
                    @click.prevent="recordOperation">
                    Nouvelle manipulation
                </a>
            </div>

        </div>

    </div>
</template>

<script>
import OperationBouteille from '../../../../js/models/OperationBouteille'
import OperationComponent from './OperationBouteille.vue'

export default {

    data() {
        return {
            ops: this.operations
        }
    },

    props: {
        operations: {
            type: Array,
            default: []
        },
        open: null,
        idFi: null
    },

    computed: {
        stateClass() {
            if (this.open === 'manip-fluide') {
                return 'open'
            } else {
                return ''
            }
        }
    },

    mounted() {

        let op = new OperationBouteille;
        op.
            getOpsForFibsdd(this.$route.params.id)
            .then(list => this.ops = list)
            .catch()

    },

    methods: {

        recordOperation() {
            let op = new OperationBouteille;
            let id = this.$route.params.id;

            op.newManipFluide(id, data => {
                this.ops.push(data);
                this.$emit('newManip', [this.ops])
            })
        },

        deleteOp(id) {
            let newOps = _.reject(this.ops, op => op.id === id[0]);
            this.ops = newOps;
            this.$emit('newManip', [newOps])
        }

    },

    components: {
        OperationComponent
    }

}
</script>



// WEBPACK FOOTER //
// ManipFluide.vue?73e52608